import React, { forwardRef, useState, useRef } from "react";
import { Form, Button, Row, Col, Alert, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./registration.scss";
import { Spinner } from "../../shared";
import { useQuery, gql, useMutation } from "@apollo/client";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cropper from "react-cropper";
import EnterpriseRecaptcha from "../../shared/EnterpriseRecaptcha";

const SIGIN_MUTATION = gql`
  mutation siginUp(
    $email: String!
    $hash: String!
    $file: String
    $name: String!
    $lastname: String!
    $date_of_birth: String
    $blood_group: String
    $blood_donation: String
    $ex_ServiceMan: String
    $contact: String!
    $whatsapp: String
    $address: String
    $post: String
    $pin: String
    $area: String
    $date_of_marriage: String
    $occupation: String
    $district: String
    $docfile: String
    $family: JSON
    $verificationtype: String
    $group_refId: String
    $captchaToken: String
  ) {
    siginUp(
      obj: {
        email: $email
        hash: $hash
        file: $file
        name: $name
        lastname: $lastname
        date_of_birth: $date_of_birth
        blood_group: $blood_group
        blood_donation: $blood_donation
        district: $district
        ex_ServiceMan: $ex_ServiceMan
        contact: $contact
        whatsapp: $whatsapp
        address: $address
        post: $post
        pin: $pin
        area: $area
        date_of_marriage: $date_of_marriage
        occupation: $occupation
        docfile: $docfile
        family: $family
        verificationtype: $verificationtype
        group_refId: $group_refId
        captchaToken: $captchaToken
      }
    ) {
      status
      message
    }
  }
`;

const GROUP_QUERY = gql`
  {
    group_list {
      _id
      title
    }
  }
`;

const BLOOD_GROUPS = [
  "A +ve",
  "A -ve",
  "B +ve",
  "B -ve",
  "AB +ve",
  "AB -ve",
  "O +ve",
  "O -ve",
];

const FAMILY_BLOOD_GROUPS = [
  { value: "A+ve", label: "A +ve" },
  { value: "A-ve", label: "A -ve" },
  { value: "B+ve", label: "B +ve" },
  { value: "B-ve", label: "B -ve" },
  { value: "AB+ve", label: "AB +ve" },
  { value: "AB-ve", label: "AB -ve" },
  { value: "O+ve", label: "O +ve" },
  { value: "O-ve", label: "O -ve" },
];

const RELATIONS = [
  "Wife",
  "Husband",
  "Father",
  "Mother",
  "Brother",
  "Sister",
  "Son",
  "Daughter",
  "Grand Mother",
  "Grand Father",
];

const emptyFamilyMember = () => ({
  name: "",
  relation: "",
  blood_group: "",
  date_of_birth: null,
});

function FieldLabel({ children, required, hint }) {
  return (
    <Form.Label>
      {children}
      {required ? <span className="req"> *</span> : null}
      {hint ? <span className="hint"> ({hint})</span> : null}
    </Form.Label>
  );
}

function ChoicePills({ name, value, onChange, options }) {
  return (
    <div className="choice-pills" role="radiogroup">
      {options.map((option) => {
        const id = `${name}-${option.value}`;
        const checked = value === option.value;
        return (
          <label
            key={id}
            htmlFor={id}
            className={`choice-pill${checked ? " is-active" : ""}`}
          >
            <input
              id={id}
              type="radio"
              name={name}
              value={option.value}
              checked={checked}
              onChange={onChange}
            />
            {option.label}
          </label>
        );
      })}
    </div>
  );
}

function DateField({ selected, onChange, placeholder, maxDate }) {
  return (
    <div className="date-field">
      <DatePicker
        dateFormat="dd/MM/yyyy"
        placeholderText={placeholder || "DD/MM/YYYY"}
        selected={selected || null}
        onChange={onChange}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        maxDate={maxDate}
        className="form-control"
        autoComplete="off"
      />
      <i className="far fa-calendar-alt" aria-hidden="true"></i>
    </div>
  );
}

function SectionHead({ icon, title }) {
  return (
    <div className="reg-card-head">
      <i className={icon} aria-hidden="true"></i>
      <h2>{title}</h2>
    </div>
  );
}

const Registration = forwardRef((props, ref) => {
  let history = useNavigate();
  const [isSpinner, setisSpinner] = useState(false);
  const [fields, setFields] = useState([emptyFamilyMember()]);
  const [inputForm, setForm] = useState({});
  const [isValid, setIsValid] = useState("");
  const [errors, setErrors] = useState({});
  const [createProfile] = useMutation(SIGIN_MUTATION);
  const [showPassword, setShowPassword] = useState(false);
  const [whatsappSame, setWhatsappSame] = useState(false);

  const [cropper, setCropper] = useState();
  const [showCrop, setCropShow] = useState(false);
  const [srcCrop, setSrc] = useState();
  const [profileImage, setProfile] = useState();

  const [cropperDoc, setDocCropper] = useState();
  const [docShow, setCropDocShow] = useState(false);
  const [srcDocCrop, setDocSrc] = useState();
  const [docImage, setDoc] = useState();
  const [captchaToken, setCaptchaToken] = useState(null);
  const recaptchaRef = useRef(null);

  const { data } = useQuery(GROUP_QUERY);

  let formChange = (event) => {
    const values = { ...inputForm };
    values[event.target.name] = event.target.value;
    if (event.target.value.toLowerCase() === "true") {
      values[event.target.name] = true;
    }
    if (event.target.value.toLowerCase() === "false") {
      values[event.target.name] = false;
    }
    if (whatsappSame && event.target.name === "contact") {
      values.whatsapp = event.target.value;
    }
    setForm(values);
  };

  let registration = async (event) => {
    if (event) event.preventDefault();
    const values = { ...inputForm };
    values["family"] = fields.filter((member) => member.name);

    let token = captchaToken;
    try {
      if (recaptchaRef.current?.execute) {
        token = await recaptchaRef.current.execute();
        setCaptchaToken(token);
      }
    } catch (err) {
      token = null;
    }

    if (validateForm(token)) {
      values["file"] = profileImage;
      values["docfile"] = docImage;
      values["captchaToken"] = token;
      setisSpinner(true);
      createProfile({ variables: { ...values } })
        .then((res) => {
          if (res.data.siginUp.status) {
            setIsValid("Created Successfully");
            setisSpinner(false);
            history("/success");
          } else {
            setIsValid(
              res.data?.siginUp?.message ||
                "Registration failed. Please complete reCAPTCHA and try again."
            );
            setisSpinner(false);
            setCaptchaToken(null);
            if (recaptchaRef.current) {
              recaptchaRef.current.reset();
            }
          }
        })
        .catch(() => {
          setisSpinner(false);
          setCaptchaToken(null);
          if (recaptchaRef.current) {
            recaptchaRef.current.reset();
          }
        });
      setTimeout(() => {
        setIsValid("");
      }, 1500);
    }
  };

  function dateofbirthDateChange(date) {
    const values = { ...inputForm };
    values["date_of_birth"] = date;
    setForm(values);
  }
  function dateofmarriageDateChange(date) {
    const values = { ...inputForm };
    values["date_of_marriage"] = date;
    setForm(values);
  }

  function handleAdd() {
    setFields([...fields, emptyFamilyMember()]);
  }
  function handleChange(i, event) {
    const values = [...fields];
    values[i][event.target.name] = event.target.value;
    setFields(values);
  }

  function handleChangeSelect(i, event) {
    const values = [...fields];
    values[i][event.target.name] = event.target.value;
    setFields(values);
  }

  function familyDateChange(i, event, date) {
    const values = [...fields];
    values[i]["date_of_birth"] = date;
    setFields(values);
  }

  function handleRemove(i) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values.length ? values : [emptyFamilyMember()]);
  }

  function collectErrors(token = captchaToken) {
    let nextErrors = {};
    let formIsValid = true;
    if (!inputForm["name"]) {
      formIsValid = false;
      nextErrors["name"] = "Please enter your first name.";
    }

    if (!inputForm["lastname"]) {
      formIsValid = false;
      nextErrors["lastname"] = "Please enter your last name.";
    }

    if (!inputForm["contact"]) {
      formIsValid = false;
      nextErrors["contact"] = "Please enter your mobile number.";
    }

    if (typeof inputForm["contact"] !== "undefined") {
      if (!inputForm["contact"].match(/^[0-9]{10}$/)) {
        formIsValid = false;
        nextErrors["contact"] = "Enter a valid 10-digit mobile number.";
      }
    }

    if (inputForm["whatsapp"] && !inputForm["whatsapp"].match(/^[0-9]{10}$/)) {
      formIsValid = false;
      nextErrors["whatsapp"] = "Enter a valid 10-digit WhatsApp number.";
    }

    if (!inputForm["date_of_birth"]) {
      formIsValid = false;
      nextErrors["date_of_birth"] = "Please enter your date of birth.";
    }

    if (
      !inputForm["blood_group"] ||
      inputForm["blood_group"] === "none"
    ) {
      formIsValid = false;
      nextErrors["blood_group"] = "Please select your blood group.";
    }

    if (
      inputForm["blood_donation"] == null ||
      inputForm["blood_donation"] === ""
    ) {
      formIsValid = false;
      nextErrors["blood_donation"] = "Please select blood donation preference.";
    }

    if (
      inputForm["ex_ServiceMan"] == null ||
      inputForm["ex_ServiceMan"] === ""
    ) {
      formIsValid = false;
      nextErrors["ex_ServiceMan"] = "Please select ex-serviceman status.";
    }

    if (!inputForm["occupation"]) {
      formIsValid = false;
      nextErrors["occupation"] = "Please enter your occupation.";
    }

    if (!inputForm["address"]) {
      formIsValid = false;
      nextErrors["address"] = "Please enter your address.";
    }

    if (!inputForm["area"]) {
      formIsValid = false;
      nextErrors["area"] = "Please enter your area.";
    }

    if (
      !inputForm["district"] ||
      inputForm["district"] === "none"
    ) {
      formIsValid = false;
      nextErrors["district"] = "Please select your district.";
    }

    if (!inputForm["post"]) {
      formIsValid = false;
      nextErrors["post"] = "Please enter your post.";
    }

    if (!inputForm["pin"]) {
      formIsValid = false;
      nextErrors["pin"] = "Please enter your PIN code.";
    }

    if (typeof inputForm["pin"] !== "undefined" && inputForm["pin"]) {
      if (!inputForm["pin"].match(/^[0-9]{6}$/)) {
        formIsValid = false;
        nextErrors["pin"] = "Enter a valid 6-digit PIN code.";
      }
    }

    if (
      !inputForm["verificationtype"] ||
      inputForm["verificationtype"] === "none"
    ) {
      formIsValid = false;
      nextErrors["verificationtype"] = "Please select verification document.";
    }

    if (!profileImage) {
      formIsValid = false;
      nextErrors["upload_Ref"] = "Please upload a profile picture.";
    }

    if (!docImage) {
      formIsValid = false;
      nextErrors["doc_upload_Ref"] = "Please upload a verification document.";
    }

    if (!inputForm["email"]) {
      formIsValid = false;
      nextErrors["email"] = "Please enter your email address.";
    }

    if (typeof inputForm["email"] !== "undefined") {
      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      );
      if (!pattern.test(inputForm["email"])) {
        formIsValid = false;
        nextErrors["email"] = "Please enter a valid email address.";
      }
    }

    if (!inputForm["hash"]) {
      formIsValid = false;
      nextErrors["hash"] = "Please enter a password.";
    }

    if (typeof inputForm["hash"] !== "undefined") {
      if (
        !inputForm["hash"].match(
          /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/
        )
      ) {
        formIsValid = false;
        nextErrors["hash"] =
          "Use 8+ characters with upper, lower, number and a symbol (@#$%&).";
      }
    }

    if (!token) {
      formIsValid = false;
      nextErrors["captcha"] = "Please complete the reCAPTCHA.";
    }

    return { formIsValid, nextErrors };
  }

  function validateForm(token = captchaToken) {
    const { formIsValid, nextErrors } = collectErrors(token);
    setErrors(nextErrors);
    if (!formIsValid) {
      const firstKey = Object.keys(nextErrors)[0];
      const scrollTargets = {
        upload_Ref: "regProfile",
        doc_upload_Ref: "regDocFile",
      };
      const node =
        document.getElementById(scrollTargets[firstKey]) ||
        document.querySelector(`[name="${firstKey}"]`);
      if (node?.scrollIntoView) {
        node.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
    return formIsValid;
  }

  const onCaptchaChange = (token) => {
    setCaptchaToken(token);
    if (token) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next.captcha;
        return next;
      });
    }
  };

  const onCaptchaExpired = () => {
    setCaptchaToken(null);
  };

  const onFileChange = (e) => {
    const reader = new FileReader();
    reader.onload = () => {
      setSrc(reader.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };
  const onDocFileChange = (e) => {
    const reader = new FileReader();
    reader.onload = () => {
      setDocSrc(reader.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleCropClose = () => {
    if (cropper && cropper.cropped) {
      setProfile(cropper.getCroppedCanvas().toDataURL());
    }
    setCropShow(false);
  };
  const handleCropCancel = () => setCropShow(false);
  const handleCropShow = () => setCropShow(true);

  const handleDocCropClose = () => {
    if (cropperDoc && cropperDoc.cropped) {
      setDoc(cropperDoc.getCroppedCanvas().toDataURL());
    }
    setCropDocShow(false);
  };
  const handleDocCropCancel = () => setCropDocShow(false);
  const handleCropDocShow = () => setCropDocShow(true);

  const toggleWhatsappSame = (event) => {
    const checked = event.target.checked;
    setWhatsappSame(checked);
    if (checked) {
      setForm({ ...inputForm, whatsapp: inputForm.contact || "" });
    }
  };

  return (
    <div id="registration">
      {isSpinner ? <Spinner /> : ""}
      <div className="reg-shell">
        <header className="reg-hero">
          <h1>
            <i className="fas fa-user" aria-hidden="true"></i>
            Create Your Account
          </h1>
          <p className="reg-lead">
            Please provide your details to create an account
          </p>
          <p className="reg-login">
            Already have an account? <Link to="/login">Log in</Link>
          </p>
        </header>

        {isValid ? (
          <Alert variant="danger" className="reg-alert">
            {isValid}
          </Alert>
        ) : null}

        <form method="post" onSubmit={registration} noValidate>
          <div className="reg-grid">
            <section className="reg-card reg-card-personal" aria-labelledby="personal-title">
              <SectionHead
                icon="fas fa-user"
                title="Personal Information"
              />
              <Form.Group className="reg-field" controlId="regName">
                <FieldLabel required hint="Text and space are allowed">
                  Name
                </FieldLabel>
                <Form.Control
                  type="text"
                  placeholder="Enter full name"
                  name="name"
                  autoComplete="given-name"
                  value={inputForm.name || ""}
                  onChange={formChange}
                />
                <span className="error-text">{errors.name}</span>
              </Form.Group>
              <Form.Group className="reg-field" controlId="regLastName">
                <FieldLabel required hint="Text and space are allowed">
                  Last Name
                </FieldLabel>
                <Form.Control
                  type="text"
                  placeholder="Enter last name"
                  name="lastname"
                  autoComplete="family-name"
                  value={inputForm.lastname || ""}
                  onChange={formChange}
                />
                <span className="error-text">{errors.lastname}</span>
              </Form.Group>
              <Row>
                <Col xs={6}>
                  <Form.Group className="reg-field" controlId="regContact">
                    <FieldLabel required hint="10 digit number">
                      Contact Number
                    </FieldLabel>
                    <Form.Control
                      type="tel"
                      inputMode="numeric"
                      pattern="[0-9]+"
                      title="please enter number only"
                      minLength="10"
                      maxLength="10"
                      placeholder="Contact number"
                      name="contact"
                      autoComplete="tel"
                      value={inputForm.contact || ""}
                      onChange={formChange}
                    />
                    <span className="error-text">{errors.contact}</span>
                  </Form.Group>
                </Col>
                <Col xs={6}>
                  <Form.Group className="reg-field" controlId="regWhatsapp">
                    <FieldLabel hint="10 digit number">
                      WhatsApp Number
                    </FieldLabel>
                    <Form.Control
                      type="tel"
                      inputMode="numeric"
                      pattern="[0-9]+"
                      title="please enter number only"
                      minLength="10"
                      maxLength="10"
                      placeholder="WhatsApp number"
                      name="whatsapp"
                      value={inputForm.whatsapp || ""}
                      onChange={formChange}
                      disabled={whatsappSame}
                    />
                    <Form.Check
                      className="reg-inline-check"
                      type="checkbox"
                      id="whatsapp-same"
                      label="Same as contact"
                      checked={whatsappSame}
                      onChange={toggleWhatsappSame}
                    />
                    <span className="error-text">{errors.whatsapp}</span>
                  </Form.Group>
                </Col>
                <Col xs={6}>
                  <Form.Group className="reg-field" controlId="regDob">
                    <FieldLabel required>Date of Birth</FieldLabel>
                    <DateField
                      selected={inputForm.date_of_birth}
                      onChange={dateofbirthDateChange}
                      placeholder="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                    <span className="error-text">{errors.date_of_birth}</span>
                  </Form.Group>
                </Col>
                <Col xs={6}>
                  <Form.Group className="reg-field" controlId="regDom">
                    <FieldLabel>Date of Marriage</FieldLabel>
                    <DateField
                      selected={inputForm.date_of_marriage}
                      onChange={dateofmarriageDateChange}
                      placeholder="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="reg-field" controlId="regProfile">
                <FieldLabel required>Profile Picture</FieldLabel>
                <button
                  type="button"
                  className={`upload-dropzone${
                    profileImage ? " has-file" : ""
                  }`}
                  onClick={handleCropShow}
                >
                  {profileImage ? (
                    <img src={profileImage} alt="Profile preview" />
                  ) : (
                    <>
                      <i className="icon" aria-hidden="true"></i>
                      <span>Upload profile image</span>
                      <small>JPG, PNG (Max. 2MB)</small>
                    </>
                  )}
                </button>
                <span className="error-text">{errors.upload_Ref}</span>
              </Form.Group>
            </section>

            <section className="reg-card reg-card-additional" aria-labelledby="details-title">
              <SectionHead
                icon="fas fa-sliders-h"
                title="Additional Information"
              />
              <Form.Group className="reg-field" controlId="regBlood">
                <FieldLabel required>Blood Group</FieldLabel>
                <Form.Select
                  name="blood_group"
                  value={inputForm.blood_group || "none"}
                  onChange={formChange}
                >
                  <option value="none">Select blood group</option>
                  {BLOOD_GROUPS.map((group) => (
                    <option key={group} value={group}>
                      {group}
                    </option>
                  ))}
                </Form.Select>
                <span className="error-text">{errors.blood_group}</span>
              </Form.Group>
              <Form.Group className="reg-field">
                <FieldLabel required>Willing for blood donation?</FieldLabel>
                <ChoicePills
                  name="blood_donation"
                  value={inputForm.blood_donation}
                  onChange={formChange}
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                />
                <span className="error-text">{errors.blood_donation}</span>
              </Form.Group>
              <Form.Group className="reg-field">
                <FieldLabel required>Ex-serviceman?</FieldLabel>
                <ChoicePills
                  name="ex_ServiceMan"
                  value={inputForm.ex_ServiceMan}
                  onChange={formChange}
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                />
                <span className="error-text">{errors.ex_ServiceMan}</span>
              </Form.Group>
              <Form.Group className="reg-field" controlId="regOccupation">
                <FieldLabel required>Occupation</FieldLabel>
                <Form.Control
                  type="text"
                  placeholder="Current occupation"
                  name="occupation"
                  value={inputForm.occupation || ""}
                  onChange={formChange}
                />
                <span className="error-text">{errors.occupation}</span>
              </Form.Group>
              <Form.Group className="reg-field" controlId="regAddress">
                <FieldLabel required hint="Text and space are allowed">
                  Address
                </FieldLabel>
                <Form.Control
                  type="text"
                  placeholder="House name / Building name"
                  name="address"
                  autoComplete="address-line1"
                  value={inputForm.address || ""}
                  onChange={formChange}
                />
                <span className="error-text">{errors.address}</span>
              </Form.Group>
              <Row>
                <Col xs={6}>
                  <Form.Group className="reg-field" controlId="regArea">
                    <FieldLabel required>Area</FieldLabel>
                    <Form.Control
                      placeholder="Area"
                      name="area"
                      value={inputForm.area || ""}
                      onChange={formChange}
                    />
                    <span className="error-text">{errors.area}</span>
                  </Form.Group>
                </Col>
                <Col xs={6}>
                  <Form.Group className="reg-field" controlId="regDistrict">
                    <FieldLabel required>District</FieldLabel>
                    <Form.Select
                      name="district"
                      value={inputForm.district || "none"}
                      onChange={formChange}
                    >
                      <option value="none">Select district</option>
                      <option value="kozhikode">Kozhikode</option>
                    </Form.Select>
                    <span className="error-text">{errors.district}</span>
                  </Form.Group>
                </Col>
                <Col xs={6}>
                  <Form.Group className="reg-field" controlId="regPost">
                    <FieldLabel required>Post</FieldLabel>
                    <Form.Control
                      placeholder="Post"
                      name="post"
                      value={inputForm.post || ""}
                      onChange={formChange}
                    />
                    <span className="error-text">{errors.post}</span>
                  </Form.Group>
                </Col>
                <Col xs={6}>
                  <Form.Group className="reg-field" controlId="regPin">
                    <FieldLabel required>PIN</FieldLabel>
                    <Form.Control
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]+"
                      title="please enter number only"
                      minLength="6"
                      maxLength="6"
                      placeholder="PIN code"
                      name="pin"
                      autoComplete="postal-code"
                      value={inputForm.pin || ""}
                      onChange={formChange}
                    />
                    <span className="error-text">{errors.pin}</span>
                  </Form.Group>
                </Col>
              </Row>
            </section>

            <section className="reg-card reg-card-account" aria-labelledby="account-title">
              <SectionHead
                icon="fas fa-id-card"
                title="Document & Account"
              />
              <Form.Group className="reg-field" controlId="regGroup">
                <FieldLabel>Select Group</FieldLabel>
                <Form.Select
                  name="group_refId"
                  value={inputForm.group_refId || "none"}
                  onChange={formChange}
                >
                  <option value="none">Select group</option>
                  {data
                    ? data.group_list.map((items) => (
                        <option key={items._id} value={items._id}>
                          {items.title}
                        </option>
                      ))
                    : null}
                </Form.Select>
              </Form.Group>
              <Form.Group className="reg-field" controlId="regDocType">
                <FieldLabel required>Verification Document Details</FieldLabel>
                <Form.Select
                  name="verificationtype"
                  value={inputForm.verificationtype || "none"}
                  onChange={formChange}
                >
                  <option value="none">Select document</option>
                  <option value="Passport">Passport</option>
                  <option value="Aadhaar">Aadhaar</option>
                  <option value="Driving Licence">Driving Licence</option>
                  <option value="Bank Passbook">Bank Passbook</option>
                </Form.Select>
                <span className="error-text">{errors.verificationtype}</span>
              </Form.Group>
              <Form.Group className="reg-field" controlId="regDocFile">
                <button
                  type="button"
                  className={`upload-dropzone doc${
                    docImage ? " has-file" : ""
                  }`}
                  onClick={handleCropDocShow}
                >
                  {docImage ? (
                    <img src={docImage} alt="Document preview" />
                  ) : (
                    <>
                      <i className="icon" aria-hidden="true"></i>
                      <span>Upload document image</span>
                      <small>JPG, PNG, PDF (Max. 2MB)</small>
                    </>
                  )}
                </button>
                <span className="error-text">{errors.doc_upload_Ref}</span>
              </Form.Group>
              <Form.Group className="reg-field" controlId="regEmail">
                <FieldLabel required>Email Id</FieldLabel>
                <div className="icon-field">
                  <i className="far fa-envelope" aria-hidden="true"></i>
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    name="email"
                    autoComplete="email"
                    value={inputForm.email || ""}
                    onChange={formChange}
                  />
                </div>
                <span className="error-text">{errors.email}</span>
              </Form.Group>
              <Form.Group className="reg-field" controlId="regPassword">
                <FieldLabel required hint="Must be more than 8 characters">
                  Password
                </FieldLabel>
                <div className="password-field">
                  <i className="fas fa-lock field-lock" aria-hidden="true"></i>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    minLength="8"
                    placeholder="Enter password"
                    name="hash"
                    autoComplete="new-password"
                    value={inputForm.hash || ""}
                    onChange={formChange}
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword((open) => !open)}
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  >
                    <i
                      className={
                        showPassword ? "fas fa-eye-slash" : "fas fa-eye"
                      }
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
                <span className="error-text">{errors.hash}</span>
              </Form.Group>
              <div className="recaptcha-wrap">
                <EnterpriseRecaptcha
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_G_TOKEN}
                  action="REGISTER"
                  onChange={onCaptchaChange}
                  onExpired={onCaptchaExpired}
                />
                <div className="error-text">{errors.captcha}</div>
              </div>
              <Button
                type="submit"
                className="btn-next register"
              >
                <i className="fas fa-user-plus" aria-hidden="true"></i> Register
              </Button>
            </section>

            <section className="reg-card family-card" aria-labelledby="family-title">
              <div className="reg-card-head family-head">
                <div className="family-title-wrap">
                  <i className="fas fa-users" aria-hidden="true"></i>
                  <h2 id="family-title">Add Family Members</h2>
                </div>
                <button
                  type="button"
                  className="add-family-btn"
                  onClick={handleAdd}
                  aria-label="Add family member"
                >
                  <i className="fas fa-plus" aria-hidden="true"></i>
                </button>
              </div>

              {fields.map((field, idx) => (
                <div className="family-row" key={`family-${idx}`}>
                  <Form.Group controlId={`family-name-${idx}`}>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      name="name"
                      placeholder="Enter name"
                      value={field.name || ""}
                      onChange={(e) => handleChange(idx, e)}
                    />
                  </Form.Group>
                  <Form.Group controlId={`family-relation-${idx}`}>
                    <Form.Label>Relation</Form.Label>
                    <Form.Select
                      name="relation"
                      value={field.relation || "none"}
                      onChange={(e) => handleChangeSelect(idx, e)}
                    >
                      <option value="none">Select relation</option>
                      {RELATIONS.map((relation) => (
                        <option key={relation} value={relation}>
                          {relation}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group controlId={`family-blood-${idx}`}>
                    <Form.Label>
                      Blood Group <span className="req">*</span>
                    </Form.Label>
                    <Form.Select
                      name="blood_group"
                      value={field.blood_group || ""}
                      onChange={(e) => handleChangeSelect(idx, e)}
                    >
                      <option value="">Select blood group</option>
                      {FAMILY_BLOOD_GROUPS.map((group) => (
                        <option key={group.value} value={group.value}>
                          {group.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group controlId={`family-dob-${idx}`}>
                    <Form.Label>
                      Date of Birth <span className="req">*</span>
                    </Form.Label>
                    <DateField
                      selected={fields[idx].date_of_birth}
                      onChange={(date) => familyDateChange(idx, null, date)}
                      placeholder="DD/MM/YYYY"
                      maxDate={new Date()}
                    />
                  </Form.Group>
                  <div className="family-action">
                    <Form.Label>Action</Form.Label>
                    <button
                      type="button"
                      className="family-remove"
                      onClick={() => handleRemove(idx)}
                      aria-label="Remove family member"
                    >
                      <i className="fas fa-trash-alt" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              ))}
            </section>
          </div>
        </form>

        <p className="reg-privacy">
          <i className="fas fa-shield-alt" aria-hidden="true"></i>
          Your information is secure with us. We will never share your details
          with third parties.
        </p>
      </div>

      <Modal show={showCrop} onHide={handleCropCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Crop profile photo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input type="file" accept="image/*" onChange={onFileChange} />
          <Cropper
            style={{ height: 282, width: "100%" }}
            aspectRatio={4 / 6}
            guides={false}
            src={srcCrop}
            onInitialized={(instance) => {
              setCropper(instance);
            }}
            viewMode={1}
            dragMode="move"
            cropBoxMovable={false}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCropCancel}>
            Cancel
          </Button>
          <Button className="btn-next" onClick={handleCropClose}>
            Save photo
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={docShow} onHide={handleDocCropCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Crop document image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input type="file" accept="image/*" onChange={onDocFileChange} />
          <Cropper
            style={{ height: 282, width: "100%" }}
            aspectRatio={4 / 6}
            guides={false}
            src={srcDocCrop}
            onInitialized={(instance) => {
              setDocCropper(instance);
            }}
            viewMode={1}
            dragMode="move"
            cropBoxMovable={false}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDocCropCancel}>
            Cancel
          </Button>
          <Button className="btn-next" onClick={handleDocCropClose}>
            Save document
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
});

export default Registration;
